/**
 * @file Pure display formatters. No data fetching, no domain logic — just
 * turning typed model values into human-readable strings.
 */

/** @param {Date|null} date @returns {string} */
export function formatDate(date) {
  if (!date) return '—';
  return date.toLocaleDateString(undefined, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
}

/** @param {Date|null} date @returns {string} */
export function formatDateTime(date) {
  if (!date) return '—';
  return date.toLocaleString(undefined, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

/**
 * Seconds -> "m:ss".
 * @param {number|null} seconds
 * @returns {string}
 */
export function formatDuration(seconds) {
  if (seconds == null) return '—';
  const m = Math.floor(seconds / 60);
  const s = Math.floor(seconds % 60);
  return `${m}:${String(s).padStart(2, '0')}`;
}

/**
 * Milliseconds -> "m:ss.mmm" (leaderboard times).
 * @param {number|null} ms
 * @returns {string}
 */
export function formatRaceTime(ms) {
  if (ms == null) return '—';
  const totalSeconds = Math.floor(ms / 1000);
  const m = Math.floor(totalSeconds / 60);
  const s = totalSeconds % 60;
  const millis = ms % 1000;
  return `${m}:${String(s).padStart(2, '0')}.${String(millis).padStart(3, '0')}`;
}

/**
 * @param {number|null} value
 * @param {string} [unit]
 * @returns {string}
 */
export function formatNumber(value, unit = '') {
  if (value == null) return '—';
  const formatted = value.toLocaleString();
  return unit ? `${formatted} ${unit}` : formatted;
}

/** @param {number} n @returns {string} Zero-padded week label, e.g. "W07". */
export function weekLabel(n) {
  return `W${String(n).padStart(2, '0')}`;
}

/**
 * @param {number} season
 * @param {number} week
 * @returns {string}
 */
export function seasonWeekLabel(season, week) {
  return `Season ${season} · ${weekLabel(week)}`;
}
